<template>
  <section
    class="flex w-full justify-center px-8 py-16 md:mb-32 md:items-center rounded-md"
  >
    <div class="gap-4 flex flex-col">
      <div class="flex items-start">
        <div class="flex flex-initial">
          <BaseButton
            color="light"
            size="extra-small"
            @click="handleOpenSignin"
          >
            <div class="gap-2 flex items-center">
              <BaseIcon icon="arrow-left" />
              <span>Sign in</span>
            </div>
          </BaseButton>
        </div>
      </div>

      <div class="bg-white w-full max-w-lg rounded-3xl border-shadow">
        <div
          class="flex items-center justify-center gap-2 border-b border-gray-100 px-16 py-6"
        >
          <router-link :to="{ name: 'home' }">
            <BaseLogo />
          </router-link>
        </div>

        <div class="space-y-6 p-6 text-center md:p-12">
          <h1 class="text-2xl font-bold lg:text-3xl lg:tracking-tight">
            Code Sent ✨
          </h1>

          <p class="text-gray-600 leading-relaxed lg:text-lg">
            Check your inbox for
            <span class="font-semibold text-gray-900">{{ email }}</span> and
            type the code below
          </p>

          <div
            class="flex justify-center text-gray-900"
            :class="{ 'opacity-50 pointer-events-none': isLoading }"
          >
            <BaseOtpInput
              :key="otpKey"
              :num-inputs="NUM_INPUTS"
              :should-auto-focus="true"
              @on-change="handleInput"
              @on-complete="handleSubmit"
            />
          </div>

          <template v-if="error">
            <div class="mt-4 text-error text-center">
              <span>{{ error.message }}</span>
            </div>

            <BaseButton
              :is-disabled="isResendDisabled"
              color="transparent"
              @click="handleResendCode"
            >
              {{
                resendTimer > 0
                  ? $t('auth.code.resendTimer', { time: resendTimer })
                  : $t('auth.code.resendCode')
              }}
            </BaseButton>
          </template>

          <!-- <div
            v-if="form.code.length === NUM_INPUTS"
            class="gap-4 flex flex-col"
          >
            <BaseButton
              class="mx-auto"
              :is-loading="isLoading"
              :is-disabled="isSubmitDisabled"
              @click="handleSubmit"
            >
              {{ $t('auth.code.login') }}
            </BaseButton>
          </div> -->
        </div>
      </div>

      <div class="text-gray-500 text-center text-sm">
        <p>
          Check spam, just in case. If you need help,
          <a
            href="mailto:capino.app@gmail.com?subject=Capino%20Sign-In%20Help"
            class="underline"
            target="_blank"
            >email us</a
          >
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import * as services from '@/services'

import BaseLogo from '@/components/Base/BaseLogo.vue'
import BaseButton from '@/components/Base/BaseButton.vue'
import BaseIcon from '@/components/Base/BaseIcon.vue'
import BaseOtpInput from '@/components/Base/BaseOptInput/BaseOtpInput.vue'

const NUM_INPUTS = 5
const RESEND_TIMER_DURATION = 20

export default {
  name: 'SigninVerifyCard',

  components: { BaseLogo, BaseButton, BaseIcon, BaseOtpInput },

  props: {
    email: { type: String, required: true }
  },

  data: () => ({
    form: {
      code: ''
    },

    otpKey: 0,

    error: null,
    isResendDisabled: true,
    resendTimer: RESEND_TIMER_DURATION,
    resendInterval: null,

    isLoading: false
  }),

  computed: {
    ...mapGetters('locale', ['currentLocale'])

    // isSubmitDisabled() {
    //   return this.form.code.length !== NUM_INPUTS
    // }
  },

  created() {
    this.NUM_INPUTS = NUM_INPUTS
  },

  beforeDestroy() {
    clearInterval(this.resendInterval)
  },

  methods: {
    ...mapActions('auth', {
      login: 'LOGIN'
    }),

    handleOpenSignin() {
      this.$emit('open-signin')
    },

    handleInput(value) {
      this.form.code = value
    },

    async handleSubmit(code = '') {
      if (this.isLoading) return

      this.error = null

      const payload = {
        email: this.email,
        code: this.form.code || code
      }

      this.isLoading = true
      const { isSuccess, error } = await this.login({ payload, type: 'email' })

      this.isLoading = false

      if (error) {
        this.error = error
        !this.resendInterval && this.startResendTimer()
      }

      if (!isSuccess) return

      this.$router.push({
        name: 'signin.success',
        params: { plan: this.$route.params.plan }
      })
    },

    async handleResendCode() {
      this.otpKey += 1
      this.error = null
      this.form.code = ''

      this.isLoading = true
      await services.auth.generateOtp({
        email: this.email,
        locale: this.currentLocale
      })
      this.isLoading = false

      this.startResendTimer()
    },

    startResendTimer() {
      this.isResendDisabled = true
      this.resendTimer = RESEND_TIMER_DURATION

      clearInterval(this.resendInterval)
      this.resendInterval = setInterval(() => {
        this.resendTimer--
        if (this.resendTimer <= 0) {
          this.isResendDisabled = false
          clearInterval(this.resendInterval)
        }
      }, 1000)
    }
  }
}
</script>
